import logo from "./logo.svg";
import "./App.scss";
import { Route, Routes, redi, Navigate } from "react-router-dom";
import Layout from "./components/Layout/Layout";
import Home from "./components/Home";
import Services from "./components/Services";
import Contact from "./components/Contact";
import Clients from "./components/Clients";
// hello
import Work from "./components/Work";
function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
      </Route>
      <Route path="/services" element={<Layout />}>
        <Route index element={<Services />} />
      </Route>

      <Route path="/clients" element={<Layout />}>
        <Route index element={<Clients />} />
      </Route>
      <Route path="/contact" element={<Layout />}>
        <Route index element={<Contact />} />
      </Route>
      {/* <Route
        path="*"
        element={<Navigate to="/" replace />}
    /> */}
    </Routes>
  );
}

export default App;
